<template>
<!-- 数字营销 -->
    <div>
        <div class="topImgs">
            <div>
                <span>以全渠道销售配合全渠道营销，领先的品销合一的实践者，为品牌客户实现从策略输出到效果执行的全整合营销服务</span>
            </div>
        </div>
        <div class="wow zoomIn marketing">
            <div class="marketingAllImg">
                <div class="marketingOne">
                    <div><img loading="lazy" class="enlargeImg" src="@/assets/img/industrialChain/shuziyingxiao_05.jpg"></div>
                    <div><img loading="lazy" class="enlargeImg" src="@/assets/img/industrialChain/shuziyingxiao_06.jpg"></div>
                    <div><img loading="lazy" class="enlargeImg" src="@/assets/img/industrialChain/shuziyingxiao_07.jpg"></div>
                </div>
                <div class="marketingTwo">
                    <div><img loading="lazy" class="enlargeImg" src="@/assets/img/industrialChain/shuziyingxiao_09.jpg"></div>
                    <div><img loading="lazy" class="enlargeImg" src="@/assets/img/industrialChain/shuziyingxiao_10.jpg"></div>
                </div>
            </div>
            <div class="marketingRight">
                <div>
                    <img loading="lazy" src="@/assets/img/industrialChain/shuziyingxiao.png">
                    <span>站外推广</span>
                </div>
                <div>
                    <img loading="lazy" src="@/assets/img/industrialChain/shuziyingxiao.png">
                    <span>网络红人定制推荐</span>
                </div>
                <div>
                    <img loading="lazy" src="@/assets/img/industrialChain/shuziyingxiao.png">
                    <span>专业博主产品软文刨析</span>
                </div>
                <div>
                    <img loading="lazy" src="@/assets/img/industrialChain/shuziyingxiao.png">
                    <span>品牌官网精准定位</span>
                </div>
                <div>
                    <img loading="lazy" src="@/assets/img/industrialChain/shuziyingxiao.png">
                    <span>站外SNS社交媒体</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteDigitalMarketing',

    data() {
        return {
            
        };
    },

    mounted() {
        // new this.$WOW.WOW().init()
    },

    methods: {
        ...mapMutations(['GoTop']),
    },
    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
    // 顶部图片
    .topImgs{
        background: url(../../assets/img/industrialChain/shuziyingxiao_02.jpg);
        background-size:100% 100%;
        height: 654px;
        display: flex;
        justify-content: center;
        align-items: center;
        div{
            width: 1000px;
            padding:20px 50px;
            background: #3b579adb;
            margin-top: -15px;
        }
        span{
            font-size: 36px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            text-align: center;
            color: #ffffff;
            line-height: 67px;
        }
    }
    // 图片和右边栏
    .marketing{
        padding: 70px 270px;
        display: flex;
        // 图片
        .marketingAllImg{
            .marketingOne,.marketingTwo{
                display: flex;
            }
            // 第一组图片
            .marketingOne div{
                width: 380px;
                height: 350px;
                overflow: hidden;
            }
            // 第二组图片
            .marketingTwo{
                div{
                    height: 350px;
                    overflow: hidden;
                }
                div:nth-child(1){
                    width: 678px;
                }
                div:nth-child(2){
                    width: 462px;
                }
            }
            img{
                height: 100%;
                width: 100%;
                cursor: pointer;
                transition:.3s;
            }
            img:hover{
                transform: scale(1.1);
            }
        }
        // 右边栏
        .marketingRight{
            width: 160px;
            height: 560px;
            padding:70px 40px;
            background: #3b589a;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            span{
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                white-space: nowrap;
                display: inline-block;
                margin-top: 10px;
            }
            img{
                width: 26px;
                height: 26px;
            }
        }
    }
    .marketing::before{
        content:'数字营销';
        z-index: 999;
        position: absolute;
        padding: 27px 35px;
        background: #3b579ac8;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
    }
</style>